import { useMemo } from "react";
import { UIAirOrder } from "@flights/types";
import { useSelector } from "react-redux";
import { getOrder } from "store/order/selectors";

export const useOrderWithDiscount = (airOrder?: UIAirOrder) => {
  const orderStore = useSelector(getOrder);

  const order = airOrder || orderStore?.airOrder;

  const isWithDiscount = useMemo(() => {
    if (!order) {
      return false;
    }

    const { appliedDiscounts, totalPrice } = order;

    return !!appliedDiscounts?.length || (totalPrice?.fee && (totalPrice.fee.units < 0 || totalPrice.fee.nanos < 0));
  }, [order]);

  return {
    isWithDiscount
  };
};
